import React from "react";

import {
  REGISTRATION_TERMS_AND_CONDITIONS_URL,
  REGISTRATION_PRIVACY_POLICY_URL
} from "../../utils/constants";

const PrivacyConsentCheckbox = ({
  checked,
  onChange,
  termsUrl = REGISTRATION_TERMS_AND_CONDITIONS_URL,
  privacyPolicyUrl = REGISTRATION_PRIVACY_POLICY_URL
}) => {
  const checkboxId = "registration-privacy-consent-checkbox";

  return (
  <div className="registration-privacy-consent">

    <label className="registration-privacy-label" htmlFor={checkboxId}>
      <input
        id={checkboxId}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="registration-privacy-checkbox-input"
        automationid="REGISTRATION_FORM_CREATEPROFILE_PRIVACY_CHECKBOX"
      />
      <span className="registration-privacy-checkbox-box" aria-hidden="true" />
      <span className="registration-privacy-text">
        I confirm that I have read, understood and agree to the
        <a href={termsUrl} target="_blank" rel="noopener noreferrer">
          {" Terms and Conditions "}
        </a>
        and
        <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
          {" Privacy Policy"}
        </a>
      </span>
    </label>

  </div>
  );
};

export default PrivacyConsentCheckbox;
